module.exports = __webpack_public_path__ + "img/gather sleeve opening.e3d0e60d.png";